exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* :host ::ng-deep .ant-badge {\r\n    margin-right: 16px;\r\n} */\r\n\r\ni.message-bell {\r\n    color: #000;\r\n    font-size: 18px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/system/message/message.component.css
// module id = ../../../../../src/app/home/components/system/message/message.component.css
// module chunks = main